import { render, staticRenderFns } from "./Screenshotsr.vue?vue&type=template&id=398ac880&"
import script from "./Screenshotsr.vue?vue&type=script&lang=js&"
export * from "./Screenshotsr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports